import { Dimensions } from 'react-native'
const DEVICE_WIDTH = Dimensions.get('window').width

export const truncate = (text: string) => {
  const avgCharWidth = 25

  const maxChars = Math.floor(DEVICE_WIDTH / avgCharWidth)

  if (text.length <= maxChars) return text
  return `${text.slice(0, maxChars - 3)}...`
}
